export default "__VITE_ASSET__DLV7roud__"